/* VSKLO core UI — storefront utilities only. Header layout/drawer/language are owned by dedicated header assets. */
(function () {
  'use strict';
  if (window.__VSKLO_CORE_UI_CLEAN__) return;
  window.__VSKLO_CORE_UI_CLEAN__ = true;

  var doc = document;
  var html = doc.documentElement;

  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  function idle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { fn(); }, { timeout: Number(timeout || 1200) });
    } else {
      window.setTimeout(fn, Math.min(Number(timeout || 1200), 900));
    }
  }
  function closest(el, selector) { return el && el.closest ? el.closest(selector) : null; }
  function scopeHas(root, selector) {
    var scope = root && root.querySelector ? root : doc;
    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) return true;
    return !!(scope.querySelector && scope.querySelector(selector));
  }

  html.classList.add('vsklo-js-ready');
  html.setAttribute('data-vsklo-locale', (window.Shopify && Shopify.locale) || html.lang || 'uk');

  function stabilizeImages(root) {
    (root || doc).querySelectorAll('img:not([decoding])').forEach(function (img) {
      img.setAttribute('decoding', 'async');
    });
  }

  /* Floating phone geometry is CSS-owned. Avoid repositioning third-party
     launchers on load/resize; repeated inline writes caused visible jumps. */

  function searchText(key, fallback) {
    var value = window.vskloStrings && window.vskloStrings.search && window.vskloStrings.search[key];
    return !value || String(value).indexOf('Translation missing') !== -1 ? fallback || '' : value;
  }

  function showSearchMessage(form, message) {
    var box = form.querySelector('[data-vsklo-search-message]');
    if (!box) {
      box = doc.createElement('div');
      box.setAttribute('data-vsklo-search-message', 'true');
      box.setAttribute('role', 'alert');
      box.className = 'vsklo-search-inline-message';
      form.appendChild(box);
    }
    box.textContent = message;
    window.clearTimeout(box.__timer);
    box.__timer = window.setTimeout(function () { if (box && box.parentNode) box.remove(); }, 3600);
  }

  function clearSearchError(form, query) {
    if (!query || !query.classList.contains('is-error') || !String(query.value || '').trim()) return;
    query.classList.remove('is-error');
    var box = form.querySelector('[data-vsklo-search-message]');
    if (box && box.parentNode) box.remove();
  }

  function initSearchForms(root) {
    (root || doc).querySelectorAll('form[action*="/search"], form[role="search"]').forEach(function (form) {
      if (form.dataset.vskloSearchReady === '1') return;
      form.dataset.vskloSearchReady = '1';
      var query = form.querySelector('input[name="q"], input[type="search"]');
      if (query) {
        query.addEventListener('input', function () { clearSearchError(form, query); });
      }
      form.addEventListener('submit', function (event) {
        var currentQuery = form.querySelector('input[name="q"], input[type="search"]');
        if (!currentQuery || String(currentQuery.value || '').trim()) return;
        event.preventDefault();
        currentQuery.classList.add('is-error');
        showSearchMessage(form, searchText('emptyQuery', 'Enter a search term'));
        try { currentQuery.focus(); } catch (error) {}
      });
    });
  }

  function isShoppingPath(pathname) {
    var path = String(pathname || window.location.pathname || '');
    if (!path || path.indexOf('/cart') !== -1 || path.indexOf('/checkout') !== -1 || path.indexOf('/account') !== -1) return false;
    return path === '/' || path.indexOf('/products/') !== -1 || path.indexOf('/collections') !== -1 || path.indexOf('/pages/') !== -1 || path.indexOf('/search') !== -1;
  }


  /* VSKLO buttons v2: passive touch press indicator, scoped to shopper CTAs.
     It is visual only and never prevents navigation, cart or form events.
     Pointer cancellation / scrolling abort the feedback immediately. */
  function initTouchButtonFeedback() {
    if (!window.PointerEvent || !window.matchMedia ||
        !window.matchMedia('(hover:none) and (pointer:coarse)').matches) return;
    var selector = [
      '#MainContent :is(a,button):is(.vsklo-ui-cta,.btn-primary,.btn-red,.btn-outline,.vsklo-btn--primary,.vsklo-btn--outline,.vcl__button,.ve-btn,.vskb-btn,.vb-btn--red,.vsc-btn--primary,.vsklo-gift-collections__button,.vsklo-home-seo-catalog__button,.vsklo-checkout-button,.vsklo-coupon-button,.vsklo-add-service,.vsklo-faq-page__button,.vsklo-delivery-btn-red,.vsklo-cabinet__button--primary,.vps-button--primary,.vsklo-premium-purchase__primary,.vsklo155card__inline-cta,.vnu-add,.veb__checkout,.vep-add,.ves__checkout,.vsklo-faq-editor__button,.vsklo-purchase-lookup__form button,.product-form__submit,.vps-cta__button,.vb-contact-form__submit,.vsklo-404__btn--red,.vsklo-privacy__btn,.vsklo-image-banner__catalog-button,.vsklo-gift-home-links__card,.vsklo-gift-hub-groups__card,.vsklo-gift-occasion__card,.vsklo-gift-ideas__card,.vsklo-gift-recipient__card,.vsklo-gift-types__card,.collection-set__item,.vsklo-gift-navigator__option,.vsklo-gift-navigator__feature,.vsklo-product-seo-hub__link,.vsklo-benefits-strip__link)',
      '#MainContent a:is(.vsklo-collection-card__link,.vsklo-gift-collections__card,.vsklo-bk-campaign__link,.vsklo-how-its-made__button,.vsklo-404__link,.vsklo-cabinet__shop-link,.vsklo-catalog-mini-card,.vsklo-btn--secondary,.vsklo-privacy__btn--ghost)',
      '#MainContent :is(.vsklo-product-parent-link,.vsklo-gift-products__head) a',
      '#minicart_wrapper a.vsklo-minicart-cart-button',
      '.footer-new a.footer-new__catalog-button',
      '.vsklo-floating-contact button.vsklo-floating-contact__submit',
      '.product-addons-popup[data-vsklo-addon-v3] .product-addons-popup__buttons :is(button.btn-primary,button.js-vsklo-cart-addons-submit,button.js-btn-atc-with-addons)',
      'body .jdgm-widget a.jdgm-write-rev-link',
      'body.product #judgeme_product_reviews :is(button[data-testid="write-review-button"],.jm-action-buttons__button)'
    ].join(', ');
    var current = null;
    var releaseTimer = 0;
    function clear() {
      window.clearTimeout(releaseTimer);
      releaseTimer = 0;
      if (current && current.node) current.node.classList.remove('vsklo-touch-pressed');
      current = null;
    }
    doc.addEventListener('pointerdown', function (event) {
      if (!event || event.pointerType !== 'touch' || !event.isPrimary || event.button !== 0) return;
      var element = event.target && event.target.closest && event.target.closest(selector);
      if (!element || element.matches(':disabled,[disabled],[aria-disabled="true"],[aria-busy="true"],.is-disabled,[role="tab"],[data-vsklo-ui-exempt],.vsklo-continue-shopping,.vsklo-minicart-continue-bottom')) return;
      clear();
      current = { node: element, id: event.pointerId, x: event.clientX, y: event.clientY };
      element.classList.add('vsklo-touch-pressed');
    }, { passive: true });
    doc.addEventListener('pointermove', function (event) {
      if (current && current.id === event.pointerId &&
          (Math.abs(event.clientX - current.x) > 12 || Math.abs(event.clientY - current.y) > 12)) clear();
    }, { passive: true });
    doc.addEventListener('pointerup', function (event) {
      if (!current || event.pointerId !== current.id) return;
      window.clearTimeout(releaseTimer);
      releaseTimer = window.setTimeout(clear, 110);
    }, { passive: true });
    doc.addEventListener('pointercancel', clear, { passive: true });
    window.addEventListener('blur', clear, { passive: true });
  }

  function rememberShoppingLocation() {
    try { if (isShoppingPath(window.location.pathname)) sessionStorage.setItem('vsklo:lastShoppingUrl', window.location.href); } catch (error) {}
  }

  function lastShoppingUrl() {
    try {
      var saved = sessionStorage.getItem('vsklo:lastShoppingUrl');
      if (saved) {
        var savedUrl = new URL(saved, window.location.origin);
        if (savedUrl.origin === window.location.origin && isShoppingPath(savedUrl.pathname)) return savedUrl.href;
      }
      var ref = doc.referrer ? new URL(doc.referrer) : null;
      if (ref && ref.origin === window.location.origin && isShoppingPath(ref.pathname)) return ref.href;
    } catch (error) {}
    return (window.routes && window.routes.collections_url) || (window.VSKLO_STOREFRONT && window.VSKLO_STOREFRONT.rootUrl) || '/';
  }

  function initContinueShopping(root) {
    (root || doc).querySelectorAll('[data-vsklo-continue-shopping]').forEach(function (link) {
      if (link.dataset.vskloContinueReady === '1') return;
      link.dataset.vskloContinueReady = '1';
      link.addEventListener('click', function (event) {
        var target = lastShoppingUrl();
        if (!target) return;
        event.preventDefault();
        window.location.href = target;
      });
    });
  }

  function cleanEscapedHtmlText(root) {
    (root || doc).querySelectorAll('.vsklo-catalog__text, .collection-hero, .rich__text-m0, h1, h2, h3, p').forEach(function (el) {
      if (!el || el.children.length) return;
      var text = el.textContent || '';
      if (!/&lt;\/?p&gt;|<\/?p>/i.test(text)) return;
      var cleaned = text.replace(/&lt;p&gt;|<p>/gi, '').replace(/&lt;\/p&gt;|<\/p>/gi, '').trim();
      if (cleaned) el.textContent = cleaned;
    });
  }

  function isVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    return rect.width > 20 && rect.height > 20 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) !== 0;
  }

  function activeOverlay() {
    var selector = [
      '.minicart.open',
      '.minicart.active',
      '.cart-drawer.open',
      '.drawer.open',
      '.drawer.active',
      '#CollectionSidebar.open',
      '.popup.active',
      '.popup.open',
      '.vsklo-cart-addon-popup.is-active',
      '[data-vsklo-default-search-panel].is-open',
      '#search-form.open',
      '.search-modal.open',
      '.search-modal.active',
      '.tingle-modal--visible'
    ].join(', ');
    var candidates = doc.querySelectorAll(selector);
    for (var i = 0; i < candidates.length; i += 1) {
      if (isVisible(candidates[i])) return true;
    }
    return false;
  }

  function syncOverlayState() {
    if (
      window.VSKLOOverlayState &&
      typeof window.VSKLOOverlayState.reconcile === 'function'
    ) {
      window.VSKLOOverlayState.reconcile();
    }
    var active = activeOverlay();
    html.classList.toggle('vsklo-ui-overlay-open', active);
    if (doc.body) doc.body.classList.toggle('vsklo-ui-overlay-open', active);
  }
  window.vskloSyncOverlayState = syncOverlayState;

  var overlayMutationSelector = '#CollectionSidebar, .minicart, .cart-drawer, .drawer, .popup, .vsklo-cart-addon-popup, [data-vsklo-default-search-panel], #search-form, .search-modal, .tingle-modal';
  var observedOverlayRoots = new WeakSet();

  function scheduleOverlaySync(delay) {
    window.clearTimeout(window.__vskloOverlaySyncTimer);
    window.__vskloOverlaySyncTimer = window.setTimeout(
      syncOverlayState,
      Math.max(0, Number(delay || 0))
    );
  }

  function observeOverlayRoot(root) {
    if (!root || observedOverlayRoots.has(root) || !('MutationObserver' in window)) return;
    observedOverlayRoots.add(root);
    new MutationObserver(function () {
      scheduleOverlaySync(40);
    }).observe(root, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
  }

  function observeOverlayRoots(scope) {
    var root = scope && scope.querySelectorAll ? scope : doc;
    if (root.nodeType === 1 && root.matches && root.matches(overlayMutationSelector)) observeOverlayRoot(root);
    if (root.querySelectorAll) root.querySelectorAll(overlayMutationSelector).forEach(observeOverlayRoot);
  }

  // Prevent fixed back-to-top/contact controls from obscuring the collection
  // filter and sorter. IntersectionObserver is torn down on AJAX replacement.
  var collectionToolbarObserver = null;
  var observedCollectionToolbar = null;
  function observeCollectionToolbar() {
    var toolbar = doc.querySelector('.sec__collection-main .toolbar-products');
    if (toolbar === observedCollectionToolbar) return;
    if (collectionToolbarObserver) {
      collectionToolbarObserver.disconnect();
      collectionToolbarObserver = null;
    }
    observedCollectionToolbar = toolbar;
    html.classList.remove('vsklo-collection-toolbar-visible');
    if (!toolbar || !('IntersectionObserver' in window)) return;
    collectionToolbarObserver = new IntersectionObserver(function (entries) {
      html.classList.toggle('vsklo-collection-toolbar-visible', entries.some(function (entry) {
        return entry.isIntersecting;
      }));
    }, { threshold: 0 });
    collectionToolbarObserver.observe(toolbar);
  }

  function refreshDynamicContent(scope) {
    var root = scope && scope.querySelectorAll ? scope : doc;
    observeCollectionToolbar();
    var escapedTextSelector = '.vsklo-catalog__text, .collection-hero, .rich__text-m0, h1, h2, h3, p';

    if (scopeHas(root, 'form[action*="/search"], form[role="search"]')) initSearchForms(root);
    if (scopeHas(root, '[data-vsklo-continue-shopping]')) initContinueShopping(root);
    if (scopeHas(root, escapedTextSelector)) cleanEscapedHtmlText(root);
    if (scopeHas(root, 'img:not([decoding])')) stabilizeImages(root);
    if (scopeHas(root, overlayMutationSelector)) observeOverlayRoots(root);

    var overlayRegistryActive =
      window.VSKLOOverlayState &&
      typeof window.VSKLOOverlayState.any === 'function' &&
      window.VSKLOOverlayState.any();

    if (overlayRegistryActive) {
      syncOverlayState();
    }
  }

  ready(function () {
    var scrollBtn = doc.getElementById('vsklo-scroll-top');
    if (scrollBtn && !scrollBtn.dataset.vskloReady) {
      scrollBtn.dataset.vskloReady = '1';
      scrollBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
    rememberShoppingLocation();
    initTouchButtonFeedback();
    initSearchForms(doc);
    initContinueShopping(doc);
    // Fresh pages start with every shared overlay closed. Observe state changes,
    // but do not force layout by measuring closed overlays during the first render.
    observeOverlayRoots(doc);
    observeCollectionToolbar();

    var isHomepage = Boolean(doc.body && doc.body.classList.contains('template-index'));
    if (isHomepage) {
      idle(function () {
        cleanEscapedHtmlText(doc);
        stabilizeImages(doc);
      }, 1400);
    } else {
      cleanEscapedHtmlText(doc);
      stabilizeImages(doc);
    }

    // Only visibility is context-aware: utilities should not cover footer
    // links/payment logos. This observer never changes button coordinates.
    var footer = doc.querySelector('.footer-new');
    if (footer && 'IntersectionObserver' in window) {
      var footerObserver = new IntersectionObserver(function (entries) {
        html.classList.toggle('vsklo-footer-visible', entries.some(function (entry) {
          return entry.isIntersecting;
        }));
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }

    doc.addEventListener('shopify:section:load', function (event) {
      refreshDynamicContent(event.target || doc);
    });

    doc.addEventListener('vsklo:content-updated', function (event) {
      refreshDynamicContent(event && event.detail && event.detail.scope ? event.detail.scope : doc);
    });

    ['modal:opened', 'modal:closed'].forEach(function (name) {
      doc.addEventListener(name, function () {
        observeOverlayRoots(doc);
        scheduleOverlaySync(0);
      });
    });

    doc.addEventListener('click', function (event) {
      var target = event && event.target;
      if (!target || !target.closest) return;
      var relevant = target.closest(
        overlayMutationSelector +
        ', [data-vsklo-mobile-drawer-open], [data-vsklo-mobile-drawer-close], [data-vsklo-default-search-trigger], .top-search-toggle, [data-action="toggle-nav"], .button-close'
      );
      if (relevant) scheduleOverlaySync(40);
    }, true);
    doc.addEventListener('keyup', function (event) {
      if (event && event.key === 'Escape') scheduleOverlaySync(40);
    }, true);

    var coreResizeFrame = 0;
    window.addEventListener('resize', function () {
      if (coreResizeFrame) return;
      coreResizeFrame = window.requestAnimationFrame(function () {
        coreResizeFrame = 0;
        if (
          window.VSKLOOverlayState &&
          typeof window.VSKLOOverlayState.any === 'function' &&
          window.VSKLOOverlayState.any() &&
          typeof window.VSKLOOverlayState.reconcile === 'function'
        ) {
          window.VSKLOOverlayState.reconcile();
        }
      });
    }, { passive: true });


  });
})();
